import {
  default as MuiTableRow,
  type TableRowProps as MuiTableRowProps,
} from '@mui/material/TableRow';

export interface TableHeadRowProps extends MuiTableRowProps {
  className?: string;
}

export default function TableHeadRow({
  className,
  ...props
}: TableHeadRowProps) {
  return <MuiTableRow className={className} {...props} />;
}
